import { IoC } from '../ServicesContainer';

export interface INavigationService {
    getHomeLink: string;

    goTo: (route: string, replace?: boolean) => void;
    goToHome: () => void;
    goToLogin: () => void;
    goToForgotPassword: () => void;
    goToResetPassword: () => void;
    goToAffaireCreate: () => void;

    goToAffaireDetails: (affaireId: string) => void;
    getAffaireDetails: (affaireId: string) => string;

    goToCompagnonCreate: () => void;
    getCompagnonDetails: (compagnonId: string) => string;
    goToCompagnonDetails: (compagnonId: string) => void;

    goToRH: () => void;
    goToRHFormations: () => void;
    goToRHAbsences: () => void;
    goToRHVisitesMedicales: () => void;

    goToEnginCreate: () => void;
    getEnginDetails: (enginId: string) => string;
    goToEnginDetails: (enginId: string) => void;

    goToMaterielCreate: () => void;
    getMaterielDetails: (materielId: string) => string;
    goToMaterielDetails: (materielId: string) => void;

    goToVehiculeCreate: () => void;
    getVehiculeDetails: (vehiculeId: string) => string;
    goToVehiculeDetails: (vehiculeId: string) => void;

    //* Controle Template
    getControleTemplateCreate: string;
    getControleTemplateDetail: (id: string) => string;
    goToControleTemplateDetail: (id: string, replace: boolean) => void;

    getCauserieDetails: (id: string) => string;
    goToCauserieDetails: (id: string) => void;
    goToCauserieCreate: () => void;
    goToCauserieList: () => void;

    goToClientCreate: () => void;
    getClientDetails: (clientId: string) => string;
    goToClientDetails: (clientId: string) => void;
}

const NavigationServiceName = 'NavigationService';
const getNavigationService = () => IoC.getLazy<INavigationService>(NavigationServiceName);

export { NavigationServiceName, getNavigationService };
